
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_17w22_1hs0v_9",
  "header": "awsui_header_17w22_1hs0v_73",
  "header-with-actions": "awsui_header-with-actions_17w22_1hs0v_83",
  "header-content": "awsui_header-content_17w22_1hs0v_88",
  "header-actions": "awsui_header-actions_17w22_1hs0v_100",
  "dismiss-button": "awsui_dismiss-button_17w22_1hs0v_108",
  "content": "awsui_content_17w22_1hs0v_112",
  "footer": "awsui_footer_17w22_1hs0v_113"
};
  